<template>
  <div class="login-footer-modular">2022 {{ copyright }}</div>
</template>


<script>
export default {
  name: "footerInfo",
  data() {
    return {
      copyright:
        " © iChuk.com iChuk 江苏爱察信息技术有限公司 增值电信业务经营许可证：苏B2-20201595 保留所有权利。",
    };
  },
  methods: {
            /**
     * 语言翻译 - 单个
     * @param {*} text
     * @param {*} callback
     * @param {*} errCallBack
     */
     translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },
    /**
     *  语言翻译 - 单个词语-
     * @param {*} text
     */
     languageTranslateByText(text, type) {
      let that = this;
      console.log("text",text);
      this.translate(
        text,
        (res) => {
            console.log("text",res);
          if (type == 4) {
            that.copyright = res.data;
          } 
        },
        (res) => {}
      );
    },

  },
  mounted(){
    this.languageTranslateByText(this.copyright, 4);
  }
};
</script>

<style lang="scss" scoped>
.login-footer-modular {
  // width: 1920px;
  // width: 1200px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 45px;
  background-color: #f6f6f6;
  text-align: center;
  font-size: 14px;
  color: #666666;
  // position: fixed;
  // bottom: 0;
  z-index: 20;
}
</style>


// WEBPACK FOOTER //
// src/components/public/footerInfo.vue